import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Slider from 'react-slick';
import ErrorBoundary from '../../error-boundary';
import Image from '../image';
import moment from 'moment';
import copy from 'copy-to-clipboard';
import {YouTubeVideoDossier} from '../content-base/paragraphs/dossier-components/component-youtube';
import {VimeoVideoDossier} from '../content-base/paragraphs/dossier-components/component-vimeo';
import ComponentVideoDossier
  from '../content-base/paragraphs/dossier-components/component-video';
import newsUpdate from './updateLikes.graphql';
// import {
//   FacebookShareButton,
//   InstapaperIcon,
//   InstapaperShareButton,
//   TwitterShareButton
// } from 'react-share';
import {restHost} from '../../config';

/**
 * Redux mapStateToProps Function to get information from Redux Store.
 * @param {Object} reduxStore - Redux Store State
 * @returns {{adminApp: *}}
 *   Redux Store.
 */

class TeaserNews extends Component {
  static defaultProps = { pagerFullPage: false };

  state = {
    // shareOpen: false,
    sliderSettings: {
      adaptiveHeight: false,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    likes: this.props.item.fieldLikes != null ? this.props.item.fieldLikes : "0",
    liked: false,
  }

  textToSelect = React.createRef();

  // toggleShare = () => this.setState({shareOpen: !this.state.shareOpen});

  // copyToClipboard = () => {
  //
  //   const TextToCopy = this.textToSelect.current.value;
  //   copy(TextToCopy);
  //
  //   alert('copied text successfully!');
  //
  // }

  like = () => {

    this.setState({
      likes: !this.state.liked ? this.state.likes + 1 : this.state.likes - 1,
      liked: !this.state.liked
    }, () => {
      const inputData = {
        "likes": this.state.likes
      }

      this.props.client.mutate({
        mutation: newsUpdate,
        variables: {
          id: this.props.item.entityId,
          input: inputData
        }
      })
    })
  }

  render() {

    const {item} = this.props,
      customClassName = classNames({
        'node-wrapper': true,
        'col-lg-4':item.fieldRasterbreite === "1_3",
        'col-lg-8':item.fieldRasterbreite === "2_3",
        'col-lg-12':item.fieldRasterbreite === "3_3"
      });

    // let shareURL = restHost + '/' + item.path.alias;

    let isThereAVideo = !!item.fieldVideoVimeo || !!item.fieldVideoYoutube || !!item.fieldVideo;

    const VideoSection = () => {

      switch (this.props.item.fieldVideoArt) {
        case 'youtube':
          return <YouTubeVideoDossier content={item} />;
        case 'vimeo':
          return <VimeoVideoDossier content={item} />;
        case 'video_file':
          return <ComponentVideoDossier content={item} />;

        default: return false;
      }
    }

    return (
      <div className={customClassName}>
        <article className="node node-teaser teaser-news">
          <div className="slider-image-section">
            {/*Add Slider if Images is not Empty*/}
            {((item.fieldTeaserbild.length !== 0) && (!isThereAVideo)) &&
            <ErrorBoundary>
              <Slider {...this.state.sliderSettings}>
                {item.fieldTeaserbild.map((imageNews, index) => {

                  if (item.fieldRasterbreite === "1_3") {
                    return (
                      <div key={index}>
                        <img src={imageNews.entity.fieldMediaImage.one.url} alt=""/>
                      </div>
                    );
                  }

                  if (item.fieldRasterbreite === "2_3") {
                    return (
                      <div key={index}>
                        <img src={imageNews.entity.fieldMediaImage.two.url} alt=""/>
                      </div>
                    );
                  }

                  if (item.fieldRasterbreite === "3_3") {
                    return (
                      <div key={index}>
                        <img src={imageNews.entity.fieldMediaImage.three.url} alt=""/>
                      </div>
                    );
                  }

                  return false;
                })}
              </Slider>
            </ErrorBoundary>
            }

            {/*Add Video if Video Field is not Emtpy and Remove Images*/}
            {isThereAVideo &&
              <ErrorBoundary>
                <VideoSection />
              </ErrorBoundary>
            }

            {/*like section*/}
            <div className="like-wrapper" onClick={this.like}>
              <div className="like">
                <img src="/themes/custom/module_box/src/images/Social-Herz.svg" alt=""/>
              </div>
              <div className="number">
                {this.state.likes}
              </div>
            </div>

            {/*share section*/}
            {/*<div className="share-wrapper">*/}
            {/*  <div className="share" onClick={this.toggleShare}>*/}
            {/*    <img src="/themes/custom/module_box/src/images/Social-teilen.svg" alt=""/>*/}
            {/*  </div>*/}
            {/*</div>*/}

            {/*{this.state.shareOpen &&*/}
            {/*<div className="share-content">*/}
            {/*  <div className="overlay" />*/}
            {/*  <div className="share-sub-wrapper">*/}
            {/*    <div className="close-icon" onClick={this.toggleShare}>*/}
            {/*      <img src="/themes/custom/module_box/src/images/icon-schliessen.svg" alt=""/>*/}
            {/*    </div>*/}
            {/*    <h3>Teilen:</h3>*/}
            {/*    <div className="share-icons">*/}
            {/*   /!*   <InstapaperShareButton url={shareURL}>*/}
            {/*        <div className="icon insta">*/}
            {/*          <img src="/themes/custom/module_box/src/images/Social-insta.svg" alt=""/>*/}
            {/*        </div>*/}
            {/*      </InstapaperShareButton>*!/*/}

            {/*        <div className="icon fb">*/}
            {/*          <FacebookShareButton url={shareURL}>*/}
            {/*            <img src="/themes/custom/module_box/src/images/Social-fb.svg" alt=""/>*/}
            {/*          </FacebookShareButton>*/}
            {/*        </div>*/}
            {/*    /!*  <div className="icon youtube">*/}
            {/*        <img src="/themes/custom/module_box/src/images/Social-youtube.svg" alt=""/>*/}
            {/*      </div>*!/*/}

            {/*        <div className="icon twitter">*/}
            {/*          <TwitterShareButton url={shareURL}>*/}
            {/*            <img src="/themes/custom/module_box/src/images/Social-Twitter.svg" alt=""/>*/}
            {/*          </TwitterShareButton>*/}
            {/*        </div>*/}

            {/*    </div>*/}
            {/*    <div className="url" onClick={this.copyToClipboard}>*/}
            {/*      <span>{`${item.path.alias.substring(0, 25)}...`}</span>*/}
            {/*      <textarea*/}
            {/*        ref={this.textToSelect}*/}
            {/*        defaultValue={`${window.location.hostname}${item.path.alias}`}*/}
            {/*        className="hidden" />*/}
            {/*      <img src="/themes/custom/module_box/src/images/copy.svg" alt=""/>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*}*/}

          </div>

          <div className="content-wrapper">
            <div className="column-wrapper">
              {item.fieldSchlagwort.length > 0 &&
              <span className="top-line">{item.fieldSchlagwort[0].entity.name}</span>
              }
              <h3>{item.title}</h3>
             {/* {item.fieldTeasertext &&
              <div className="teaser text" dangerouslySetInnerHTML={{ __html: item.fieldTeasertext.value }} />
              }*/}

              {item.fieldTextAbschnitte.length === 1 && item.fieldTextAbschnitte[0].entity.fieldTextAbschnitt &&
                <div className="teaser text" dangerouslySetInnerHTML={{ __html: item.fieldTextAbschnitte[0].entity.fieldTextAbschnitt.processed }} />
              }

              {item.fieldTextAbschnitte.length > 1 &&
              <Slider {...this.state.sliderSettings}>
                {item.fieldTextAbschnitte.map((textItem, y) =>
                  <div key={y} className="teaser text" dangerouslySetInnerHTML={{ __html: textItem.entity.fieldTextAbschnitt ? textItem.entity.fieldTextAbschnitt.processed : null }} />
                )}
              </Slider>
              }

            </div>
            <div className="meta-wrapper">
              <div className="date">
                {moment.unix(item.created).format('DD. MMMM YYYY')}
              </div>
            </div>
          </div>

        </article>
      </div>
    );
  }
}

TeaserNews.propTypes = {
  item: PropTypes.object.isRequired,
  pagerFullPage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired
};

export default TeaserNews;
